type Permission = {

}

type AuthHookProps = {
    permission: string,
    userPermissions: Array<string>
}

const useAuth = (props: AuthHookProps) => {

    const { permission, userPermissions } = props

    return userPermissions.includes(permission);

}

export default useAuth